import React, { memo } from "react";
import PropTypes from "prop-types";
import ButterflyPhoto from "../../assets/images/butterfly.png";
import ButterflyClearPhoto from "../../assets/images/clear_butterfly.png";
import "./style.scss";

function Butterflies({ countEllipses, className, isMobile, type = "blur" }) {
  Butterflies.propTypes = {
    countEllipses: PropTypes.number,
    classPrefix: PropTypes.string,
    className: PropTypes.string,
    isMobile: PropTypes.bool,
    type: PropTypes.string,
  };
  let cls = ["butterfly"];
  if (isMobile) {
    cls = ["butterfly-mobile"];
  }

  const ellipses = Array.from({ length: countEllipses }, (_, i) => i + 1);
  return ellipses.map((numberEllipse) => {
    return (
      // <div
      //   key={++numberEllipse}
      //   className={`${className}-${numberEllipse} ${cls.join(" ")}`}
      // >
      <img
        key={++numberEllipse}
        className={`${className}-${numberEllipse} ${cls.join(" ")}`}
        src={type === "blur" ? ButterflyPhoto : ButterflyClearPhoto}
        alt={`butterfly-${className}`}
      />
      // </div>
    );
  });
}

export default memo(Butterflies);
